import React, { useState } from "react";
import "./ProductCard.css";
import placeholder from "../../assets/placeholder.jpg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { toast } from "react-toastify";

export default function ProductCard({ product }) {
  const navigate = useNavigate();

  // const [imgSrc, setImgSrc] = useState(
  //   product?.image?.length > 0 ? product.image[0].url : placeholder
    
  // );
  // const imgSrc =
  // product?.image?.[0]?.url || placeholder;
  // const imgSrc =
  // product?.image?.[0]?.url ||
  // product?.image ||
  // placeholder;
  const imgSrc =
  product?.image?.url || placeholder;

console.log("IMAGE URL:", imgSrc);
// console.log(product.image[0].url);

  const [isFavorite, setIsFavorite] = useState(product?.isFavorite || false);

  if (!product) return null;

  const {
    id,
    name,
    price,
    description,
    currencyType,
    stock,
    status,
  } = product;

  const currency = currencyType || "ريال";

  const isOutOfStock =
    Number(stock) <= 0 || status?.toLowerCase().includes("out");

  /* ================= FAVORITE ================= */

  const toggleFavorite = async (e) => {
    e.stopPropagation();

    const token = localStorage.getItem("token");

    if (!token) {
      toast.info("يجب تسجيل الدخول لإضافة المنتج إلى المفضلة ❤️");
      return;
    }

    setIsFavorite((prev) => !prev);

    try {
      await axios.get(
        BaseUrl + BuyerServicesUrl.AddProductToFavorites.replace("{id}", id),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (err) {
      setIsFavorite((prev) => !prev);
      toast.error("حدث خطأ أثناء تحديث المفضلة ❌");
    }
  };

  /* ================= ADD TO CART ================= */

  const addToCart = async (e) => {
    e.stopPropagation();

    if (isOutOfStock) return;

    const token = localStorage.getItem("token");

    if (!token) {
      toast.info("يجب تسجيل الدخول لإضافة المنتج إلى السلة 🛒");
      return;
    }

    try {
      await axios.post(
        `${BaseUrl}${BuyerServicesUrl.AddToCart}`,
        {
          product_id: id,
          quantity: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      toast.success("تمت الإضافة إلى السلة 🛒");

      window.dispatchEvent(
        new CustomEvent("cartUpdated", {
          detail: "increment",
        })
      );
    } catch (err) {
      const message =
        err.response?.data?.data || err.response?.data?.message || "";

      if (message.toLowerCase().includes("same saller")) {
        toast.error("لا يمكن إضافة منتجات من بائع مختلف ❌");
      } else if (message.toLowerCase().includes("stock")) {
        toast.info("المنتج غير متوفر حالياً 🚫");
      } else {
        toast.error("حدث خطأ أثناء الإضافة ❌");
      }

      console.error(err.response?.data || err);
    }
  };
console.log(product);
  return (
    <div
      className="product-card"
      onClick={() => navigate(`/advertisementdetails/${id}`)}
      style={{ cursor: "pointer" }}
    >
      <div className="img-wrapper" style={{ position: "relative" }}>
        <div
          className={`fav-btn ${isFavorite ? "active" : ""}`}
          onClick={toggleFavorite}
        >
          {isFavorite ? "❤" : "♡"}
        </div>

        <img
          src={imgSrc}
          alt={name}
          className="product-img"
          // onError={() => setImgSrc(placeholder)}
          onError={(e) => {
  e.target.src = placeholder;
}}
        />
      </div>

      <div className="product-info">
        <h1 className="product-title">
          {name?.split(" ").slice(0, 3).join(" ")}...
        </h1>

        <p className="product-desc">
          {(() => {
            const words = (description || "")
              .trim()
              .split(/\s+/)
              .filter(Boolean);

            const short = words.slice(0, 4).join(" ");

            return words.length > 4 ? `${short}...` : short;
          })()}
        </p>

        <div className="price-row">
          <span className="current-price">
            {price} {currency}
          </span>
        </div>
      </div>

      <button
        className={`addcart text-white border-0 pt-2 pb-2 mb-3 ${
          isOutOfStock ? "cart-disabled" : ""
        }`}
        disabled={isOutOfStock}
        onClick={addToCart}
      >
        {isOutOfStock ? "غير متوفر" : "أضف الى السلة"}
      </button>
    </div>
  );
}